import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { updateField, updateFields } from '../modules/fields/fields-actions'
import { showLoading } from '../modules/status/status-actions'

import { composeWithDevTools } from 'redux-devtools-extension'
import { createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createHashHistory'
import { combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { ReducersMapObject, Store } from 'redux'


type Reducer = (Object, string) => Object;


interface Props{
    reducers:ReducersMapObject,
    preventReduxDevTools?:boolean
}


interface State{
    store:Store<any>
}


export default class extends React.Component<Props, State>{

    createStore(){
        const composeEnhancers = composeWithDevTools({
            // Specify name here, actionsBlacklist, actionsCreators and other options if needed
        });

        const middleware = applyMiddleware(
            thunk,
            routerMiddleware( createHistory() ),
        )
    
        var store = createStore(
            combineReducers( this.props.reducers ),
            {},
            this.props.preventReduxDevTools ? middleware : composeEnhancers( middleware )
        )
       
    
        return store;
    }


    componentWillMount(){
        const store = this.createStore();

        window["showLoading"] = function(){
            store.dispatch( showLoading("window show loading") )
        }
    
        window["updateFields"] = function(fields){
            store.dispatch( updateFields(fields) )
        }
    
        window["updateField"] = function(fieldName, value){
            store.dispatch( updateField(fieldName, value) )
        }
    
        window["dispatchAction"] = function(action){
            store.dispatch(action);
        }

        this.setState({
            ...this.state,
            store
        })
    }


    render(){
        if(!this.state || !this.state.store) return null;
        return (
            <Provider store={ this.state.store }>
                { this.props.children }
            </Provider>
        )
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/chu-form-provider.tsx